import * as CONSTANTS from "../constants/actions/myanalog";

/**
 * @name INITIAL_STATE
 * @constant
 * @description
 * @type {Object}
 * @default
 */
const INITIAL_STATE = {
  isOpen: false,
  onConfirm: () => {},
  onCancel: () => {},
  modalTitle: "",
  modalMessage: "",
  modalConfirmMessage: "",
  haveFilter: false,
  filterText: "",
  haveActions: false,
  isAddToMyAnalog: false,
  haveDropDown: false,
  dropDownItems: [],
  dropDownTitle: "",
  dropDownDefaultText: "",
  confirmState: null,
  productID: "",
  projectID: "",
  productURL: "",
  modalError: null,
  tableModal: null,
  transalationObject: null,
  tableSuccessState: false,
  productsSuccessState: [],
};

/**
 * **DO NOT** Manipulate the state directly, always apply to a new object first!! If you don't redux will not
 * recognize a change in the data and the components will not receive the correct information.
 *
 * @name reducer
 * @function
 * @description Handles reduction of data accross components for the piece of the site implied by the filename
 * @param {Object} state Current state of the data
 * @param {Object} action Information passed from the corresponding actions file
 */
const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONSTANTS.SHOW_MODAL:
      return {
        ...state,
        isOpen: true,
      };
    case CONSTANTS.HIDE_MODAL:
      return {
        ...state,
        isOpen: false,
        onConfirm: () => {},
        onCancel: () => {},
        modalTitle: "",
        modalMessage: "",
        modalConfirmMessage: "",
        filterText: "",
        haveFilter: false,
        haveActions: false,
        isAddToMyAnalog: false,
        haveDropDown: false,
        dropDownItems: [],
        dropdownTitle: "",
        dropDownDefaultText: "",
        confirmState: null,
        productID: "",
        productURL: "",
        projectID: "",
        modalError: null,
        tableModal: null,
        transalationObject: null,
      };
    case CONSTANTS.SET_VALUES:
      return {
        ...state,
        onConfirm: action.payload.onConfirm,
        onCancel: action.payload.onCancel,
        modalTitle: action.payload.modalTitle,
        modalMessage: action.payload.modalMessage,
        modalConfirmMessage: action.payload.modalConfirmMessage,
        filterText: action.payload.filterText,
        haveFilter: action.payload.haveFilter,
        haveActions: action.payload.haveActions,
        isAddToMyAnalog: action.payload.isAddToMyAnalog,
        haveDropDown: action.payload.haveDropDown,
        dropDownTitle: action.payload.dropDownTitle,
        dropDownDefaultText: action.payload.dropDownDefaultText,
        dropDownItems: action.payload.dropDownItems,
        confirmState: action.payload.confirmState,
        productID: action.payload.productID,
        productURL: action.payload.productURL,
        productsURL: action.payload.productsURL,
        projectID: action.payload.projectID,
        tableModal: action.payload.tableModal,
      };
    case CONSTANTS.SET_ERROR:
      return {
        ...state,
        modalError: action.payload,
      };
    case CONSTANTS.SET_DROPDOWN_VALUES:
      return {
        ...state,
        dropDownItems: action.payload,
      };
    case CONSTANTS.SET_TRANSLATION_VALUES:
      return {
        ...state,
        transalationObject: action.payload,
      };
    case CONSTANTS.SET_SUCCESS:
      return action.payload.productsSuccessState
        ? {
            ...state,
            productsSuccessState: [
              ...state.productsSuccessState,
              action.payload.productsSuccessState,
            ],
          }
        : {
            ...state,
            tableSuccessState: action.payload.tableSuccessState,
          };
    default:
      return state;
  }
};

export default reducer;
